import { createSlice } from '@reduxjs/toolkit';
import { storage } from '../../utils/helpers';

const initialState = {
  user: storage.get('user') || null,
  accessToken: storage.get('accessToken') || null,
  refreshToken: storage.get('refreshToken') || null,
  isAuthenticated: !!(storage.get('accessToken') && storage.get('user')),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, tokens } = action.payload;
      state.user = user;
      state.accessToken = tokens.accessToken;
      state.refreshToken = tokens.refreshToken;
      state.isAuthenticated = true;
      
      // Save to localStorage
      storage.set('user', user);
      storage.set('accessToken', tokens.accessToken);
      storage.set('refreshToken', tokens.refreshToken);
    },
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      
      // Remove from localStorage
      storage.remove('user');
      storage.remove('accessToken');
      storage.remove('refreshToken');
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      storage.set('user', state.user);
    },
  },
});

export const { setCredentials, logout, updateUser } = authSlice.actions;

export default authSlice.reducer;

// Selectors
export const selectCurrentUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectUserRole = (state) => state.auth.user?.role;